import {NavbarItem} from "../Types/NavbarItem";

/** Live Blazor (Gen2) client — used for drawer items that are not implemented in this app yet. */
function getLegacyMesmaAppOrigin(): string {
  const hostname = window.location.hostname.toLowerCase();
  if (hostname === "localhost") return "http://localhost:55338";
  if (hostname === "appng-innovate.mesma.io") return "https://appng.mesma.co.uk";
  return "https://app.mesma.io";
}

export const LEGACY_MESMA_APP_ORIGIN = getLegacyMesmaAppOrigin();

const legacyUrl = (path: string): string =>
  `${LEGACY_MESMA_APP_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;

export function isLegacyMesmaNavItem(item: NavbarItem): boolean {
  return item.type === "navigation" && item.url.startsWith(LEGACY_MESMA_APP_ORIGIN);
}

/** Open the classic Blazor app in a new tab (with allowLegacy bypass). */
export function navigateToLegacyMesma(pathOrUrl: string): void {
  const url = pathOrUrl.startsWith("http")
    ? new URL(pathOrUrl)
    : new URL(pathOrUrl.startsWith("/") ? pathOrUrl : `/${pathOrUrl}`, LEGACY_MESMA_APP_ORIGIN);
  url.searchParams.set("allowLegacy", "1");
  const finalUrl = url.toString();
  console.log("[Mesma LegacyRedirect] [React navigateToLegacyMesma] Opening legacy Blazor tab", {
    input: pathOrUrl,
    legacyOrigin: LEGACY_MESMA_APP_ORIGIN,
    finalUrl,
    allowLegacy: url.searchParams.get("allowLegacy"),
    reactHostname: window.location.hostname,
  });
  window.open(finalUrl, "_blank", "noopener,noreferrer");
}

export const NavbarData : NavbarItem[] = [
  /*
    {
        id: 1,
        type: "navigation",
        title: "Dashboard",
        icon: "/img/NavIcons/dashboard.svg",
        active: true,
        url: "/",
        class: "nav-item-dashboard"
      },
      {
        id: 2,
        type: "navigation",
        title: "Calendar",
        icon: "/img/NavIcons/calendar.svg",
        active: false,
        url: "/calendar",
        class: ""
      },
      {
        id: 3,
        type: "navigation",
        title: "KPI",
        icon: "/img/NavIcons/kpi.svg",
        active: false,
        url: "/kpi",
        class: "nav-item-evaluate"
      },
  */
      {
        id: 4,
        type: "navigation",
        title: "Evaluate",
        icon: "/img/NavIcons/evaluate.svg",
        active: false,
        url: "/evaluate/active",
        class: "nav-item-evaluate"
      },
      {
        id: 5,
        type: "navigation",
        title: "Track",
        icon: "/img/NavIcons/improve.svg",
        active: false,
        url: "/improve",
        class: "nav-item-improve"
      },
      {
        id: 6,
        type: "navigation",
        title: "Develop",
        icon: "/img/people.svg",
        active: false,
        url: "/develop",
        class: "nav-item-develop"
      },
      /*{
        id: 5,
        type: "navigation",
        title: "Enquire",
        icon: "/img/NavIcons/enquire.svg",
        active: false,
        url: "/enquire",
        class: "nav-item-evaluate"
      }
      */      {
        id: 3,
        type: "navigation",
        title: "Analyse",
        icon: "/img/NavIcons/enquire.svg",
        active: false,
        url: "/analyse",
        class: "nav-item-analyse"
      },
      {
        id: 9,
        type: "navigation",
        title: "Library",
        icon: "/img/NavIcons/library.svg",
        active: false,
        url: "/library",
        class: "nav-item-library"
      },
      /*{
        id: 7,
        type: "navigation",
        title: "Improve",
        icon: "/img/NavIcons/improve.svg",
        active: false,
        url: "/improve",
        class: "nav-item-improve"
      },
      {
        id: 8,
        type: "navigation",
        title: "Develop",
        icon: "/img/NavIcons/develop.svg",
        active: false,
        url: "/develop",
        class: "nav-item-develop"
      },
      {
        id: 9,
        type: "navigation",
        title: "Library",
        icon: "/img/NavIcons/library.svg",
        active: false,
        url: "/library",
        class: "nav-item-library"
      },
      {
        id: 10,
        type: "navigation",
        title: "Resources",
        icon: "/img/NavIcons/resources.svg",
        active: false,
        url: "/resources",
        class: "nav-item-settings"
      },
      {
        id: 11,
        type: "navigation",
        title: "Organisation",
        icon: "/img/NavIcons/organisation.svg",
        active: false,
        url: "/organisation",
        class: "nav-item-settings"
      },
      {
        id: 12,
        type: "navigation",
        title: "Department",
        icon: "/img/NavIcons/department.svg",
        active: false,
        url: "/department",
        class: "nav-item-settings"
      },*/
      {
        id: 13,
        type: "navigation",
        title: "Admin",
        icon: "/img/NavIcons/settings.svg",
        active: false,
        url: "/admin",
        class: "nav-item-settings"
      },
      {
        id: 1,
        type: "navigation",
        title: "Dashboard",
        icon: "/img/NavIcons/dashboard.svg",
        active: false,
        url: legacyUrl("/Dashboard"),
        class: "nav-item-dashboard"
      },
      {
        id: 21,
        type: "navigation",
        title: "Notifications",
        icon: "/img/NavIcons/notifications.svg",
        active: false,
        url: legacyUrl("/Notifications"),
        class: ""
      },
      {
        id: 17,
        type: "navigation",
        title: "Calendar",
        icon: "/img/NavIcons/calendar.svg",
        active: false,
        url: legacyUrl("/QualityCalendar"),
        class: ""
      },
      {
        id: 18,
        type: "navigation",
        title: "KPI",
        icon: "/img/NavIcons/kpi.svg",
        active: false,
        url: legacyUrl("/KPI"),
        class: "nav-item-evaluate"
      },
      {
        id: 20,
        type: "navigation",
        title: "Resources",
        icon: "/img/NavIcons/resources.svg",
        active: false,
        url: legacyUrl("/Resources"),
        class: "nav-item-settings"
      },
      {
        id: 22,
        type: "navigation",
        title: "Partner controls",
        icon: "/img/NavIcons/organisation.svg",
        active: false,
        url: legacyUrl("/PartnerControls"),
        class: "nav-item-settings"
      },
      {
        id: 23,
        type: "navigation",
        title: "Department controls",
        icon: "/img/NavIcons/department.svg",
        active: false,
        url: legacyUrl("/DepartmentControls"),
        class: "nav-item-settings"
      },
      {
        id: 14,
        type: "video",
        title: "Video",
        icon: "/img/NavIcons/play.svg",
        active: false,
        videos: {
          "develop/active": {
            title: "Develop - Home Page",
            src: "/video/Develop - Home Page.mp4"
          },
          "develop/archive": {
            title: "Develop - Archive Page",
            src: "/video/Develop - Archive Page.mp4"
          },
          "develop/diagnostic": {
            title: "Develop - Diagnostic Page",
            src: "/video/Develop - Diagnostic Page.mp4"
          },
          "develop/summary": {
            title: "Develop - Summary Page",
            src: "/video/Develop - Summary Page.mp4"
          },
          "evaluate/active": {
            title: "Evaluate - Home Page",
            src: "/video/Evaluate - Home Page.mp4"
          },
          "evaluate/archive": {
            title: "Evaluate - Archive Page",
            src: "/video/Evaluate - Archive Page.mp4"
          },
          "evaluate/diagnostic": {
            title: "Evaluate - Diagnostic Page",
            src: "/video/Evaluate - Diagnostic Page.mp4"
          },
          "evaluate/summary": {
            title: "Evaluate - Summary Page",
            src: "/video/Evaluate - Summary Page.mp4"
          },
          "track/active": {
            title: "Track - Home Page",
            src: "/video/Track - Home Page.mp4"
          },
          "track/plan": {
            title: "Track - Plan Page",
            src: "/video/Track - Plan Page.mp4"
          },
          "analyse": {
            title: "Analyse",
            src: "/video/Analyse.mp4"
          },
          "admin/create-a-template/define-fields": {
            title: "Admin - Create Template - Fields",
            src: "/video/Admin - Create Template - Fields.mp4"
          },
          "admin/create-a-template/define-structure": {
            title: "Admin - Create Template - Sections and Criteria",
            src: "/video/Admin - Create Template - Sections and Criteria.mp4"
          },
          "admin/create-a-template/define-questions": {
            title: "Admin - Create Template - Questions",
            src: "/video/Admin - Create Template - Questions.mp4"
          },
          "admin/create-a-template/additional-information": {
            title: "Admin - Create Template - Additional Information",
            src: "/video/Admin - Create Template - Additional Information.mp4"
          },
          "admin/manage-templates": {
            title: "Admin - Manage Templates",
            src: "/video/Admin - Manage Templates.mp4"
          },
          "admin/mandate-templates": {
            title: "Admin - Mandate Templates",
            src: "/video/Admin - Mandate Templates.mp4"
          }
        },
        class: "nav-item-settings",
        align: "bottom"
      },
      {
        id: 15,
        type: "navigation",
        title: "Portal",
        icon: "/img/NavIcons/code.svg",
        active: false,
        url: "/template-editor/active",
        class: "nav-item-settings",
        align: "bottom"
      }
]